module.exports = __webpack_public_path__ + "img/1476607710.651c7f5a.jpg";